module.exports = __webpack_public_path__ + "static/media/iconLike.5042fdb1.svg";